import * as React from "react";
import styled from "styled-components";
import { InlineButton } from "./Button";
import { Popover, usePopover } from "./Popover";
import { TagList } from "./Tag";
import { style } from "./style";

export type Props = {
  tags: string[];
  maxTags?: number;
  noWrap?: boolean;
  renderTag: (tag: string, index: number) => React.ReactElement;
};

const Wrapper = styled.div`
  display: flex;
  width: 100%;
`;

const RemainderCount = styled(InlineButton)`
  padding: 0 ${style.vars.space["3"]};
  align-self: center;
`;

export const TagGroup: React.FC<Props> = ({ tags, maxTags = 1, renderTag, noWrap }) => {
  const { togglePopover, ...popoverProps } = usePopover();

  // ensures at least 1 tag is shown
  const normalizedMaxTags = maxTags <= 1 ? 1 : maxTags;

  if (tags.length === 0) {
    return null;
  }

  const initialTags = tags.slice(0, normalizedMaxTags);
  const remainingTags = tags.slice(normalizedMaxTags);

  return (
    <Wrapper>
      <TagList $noWrap={noWrap}>{initialTags.map((tag, index) => renderTag(tag, index))}</TagList>

      {remainingTags.length > 0 && (
        <Popover
          content={<TagList>{remainingTags.map((tag, index) => renderTag(tag, index))}</TagList>}
          placement="top-start"
          interactive
          {...popoverProps}
        >
          <RemainderCount onClick={togglePopover}>+{remainingTags.length}</RemainderCount>
        </Popover>
      )}
    </Wrapper>
  );
};
